<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="description-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-description-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="data"
              rules="required"
            >
              <b-form-group
                label="data"
                label-for="v-data"
              >
                <flat-pickr
                  id="v-data"
                  v-model="form.data"
                  :state="errors.length > 0 ? false : null"
                  name="fieldDate"
                  class="form-control"
                  :config="{
                    altInput: true,
                    altFormat: 'd/m/Y',
                    enableTime: false,
                    dateFormat: 'Y-m-d\\TH:i:ss\\Z'
                  }"
                  data-cy="data-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-data-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            cols="12"
            sm="6"
          >
            <b-form-group
              label="Fixo (Repetir Anualmente)"
              label-for="v-fixo"
            >
              <b-form-checkbox
                v-model="form.fixo"
                :checked="form.fixo"
                name="check-button"
                switch
                inline
                data-cy="fixo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.fixo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col
            v-if="form.id"
            cols="12"
            sm="6"
          >
            <b-form-group
              label="Ativo"
              label-for="v-ativo"
            >
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import flatPickr from 'vue-flatpickr-component'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('feriadoSettingsModule', {
      feriado: state => state.feriado,
    }),
    canInsert() {
      return this.verificarPermissao('ROLE_FERIADO_INSERIR')
    },
    canEdit() {
      return this.verificarPermissao('ROLE_FERIADO_ATUALIZAR')
    },
    canEditOrInsert() {
      if (this.form.id) {
        return this.canEdit
      }
      return this.canInsert
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    flatPickr,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Feriado',
      required,
      form: {
        descricao: '',
        data: '',
        fixo: false,
        ativo: true,
      },
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.feriado))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('feriadoSettingsModule/reset')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('feriadoSettingsModule/edit', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('feriadoSettingsModule/insertNew', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        descricao: '',
        data: '',
        ativo: true,
        fixo: false,
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
